export default "__VITE_ASSET__e4144936__"